import { render, staticRenderFns } from "./import-recipients.vue?vue&type=template&id=7de63c90&scoped=true&"
import script from "./import-recipients.vue?vue&type=script&lang=js&"
export * from "./import-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de63c90",
  null
  
)

export default component.exports